import { formatPrice } from 'common/utils/format'
import { DISCOUNT_METHODS } from 'artkive/utils/promoCode'

const calculateOrderSummaryPrices = ({ fullPriceInfo = {}, showEachSuffix }) => {
  const { promo_discount_details, total = 0, before_discount = 0, promo_discount = 0, currency_symbol } = fullPriceInfo
  const { discount_method: discountMethod, amount } = promo_discount_details || {}

  let discountLabel

  switch (discountMethod) {
    case DISCOUNT_METHODS.FLAT:
      discountLabel = `${currency_symbol}${amount} OFF`
      break
    case DISCOUNT_METHODS.FLAT_PER_ITEM:
      discountLabel = `${currency_symbol}${Math.abs(promo_discount)} OFF${showEachSuffix ? '/ea' : ''}`
      break
    case DISCOUNT_METHODS.PERCENTAGE:
      discountLabel = `-${amount * 100}%`
      break
    case DISCOUNT_METHODS.FREE_USB:
      discountLabel = 'FREE USB'
      break
    default:
      discountLabel = null
  }

  return {
    finalPrice: formatPrice(total, 'long', currency_symbol),
    price: formatPrice(before_discount, 'long', currency_symbol),
    discountLabel,
  }
}

export default calculateOrderSummaryPrices
